export default __webpack_public_path__ + "static/media/fb.24d9ca90.svg";